<template>
  <div
    class="justify-content-center py-1"
    :class="`sumo-bg-${bannerDetails.bg_color}`"
  >
    <DealBannerContent
      :banner-details="bannerDetails"
      :display-timer="displayTimer"
      :sticky-timer="mobileStickyTimer || desktopStickyTimer"
      tooltip-id="mobile-deal-banner-tooltip"
    />
  </div>
</template>

<script>
import DealBannerContent from './DealBannerContent.vue';

export default {
  name: 'DealBannerHeader',
  components: {
    DealBannerContent,
  },
  props: {
    bannerDetails: {
      type: Object,
      required: true,
    },
    displayTimer: {
      type: Boolean,
      default: false,
    },
    mobileStickyTimer: {
      type: Boolean,
      default: false,
    },
    desktopStickyTimer: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
  .sumo-bg-pdp-black-friday-bg-color {
    background-color: #ffca54;
  }
</style>
